module.exports = __webpack_public_path__ + "static/media/SmartShop_6-615w.8742881b.png";